import type {GridRowSelectionModel} from '@mui/x-data-grid'
import {createSlice} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import {getUrlParams} from '@app/util-functions'
import type {ProgramInterface} from '@shared/interfaces/program'

type InitialStateType = {
  selected: string[]
  url: string
}

const initialState: InitialStateType = {
  selected: [],
  url: '',
}

export const programs = createSlice({
  name: 'programs',
  initialState,
  reducers: {
    setGlobalSelectedPrograms: (
      state,
      action: PayloadAction<ProgramInterface[] | string[] | GridRowSelectionModel>,
    ) => {
      if (action.payload) {
        // Handle MUI X DataGrid v8 selection model format: {type: 'include'|'exclude', ids: Set<GridRowId>}
        let payload: ProgramInterface[] | string[]

        if (
          typeof action.payload === 'object' &&
          'ids' in action.payload &&
          action.payload.ids instanceof Set
        ) {
          // v8 format: convert Set to array
          payload = Array.from(action.payload.ids) as string[]
        } else if (Array.isArray(action.payload)) {
          // Array format (v7 or direct array)
          payload = action.payload
        } else {
          // Fallback to empty array
          payload = []
        }

        if (payload.length > 0 && payload[0]) {
          if (typeof payload[0] === 'object' && 'id' in payload[0]) {
            const programsIds = payload.map((item) => (item as ProgramInterface).id)
            const programsURL = getUrlParams(programsIds, 'program')
            return {
              ...state,
              selected: programsIds,
              url: programsURL,
            }
          }
          const programsURL = getUrlParams(payload as string[], 'program')
          return {
            ...state,
            selected: payload as string[],
            url: programsURL,
          }
        }
      }
      return {
        ...state,
        selected: [],
        url: '',
      }
    },
  },
})

// Action creators are generated for each case reducer function
export const {setGlobalSelectedPrograms} = programs.actions
export default programs.reducer
